import React, { useEffect } from 'react';
import Header from './Header';

const WiderrufsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#E8F5E0] to-white">
      <Header />
      
      <div className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            
            <div className="border-b-2 border-[#1A3A2E] pb-6 mb-8">
              <h1 className="text-4xl font-bold text-[#1A3A2E] mb-2">
                Widerrufsbelehrung
              </h1>
            </div>

            <div className="space-y-8 text-gray-800">
              {/* Widerrufsrecht */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">Widerrufsrecht</h2>
                <p className="leading-relaxed mb-4">
                  Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beginnt 14 Tage ab dem Zeitpunkt, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, den Kaufgegenstand in Besitz genommen haben bzw. hat.
                </p>
                <p className="leading-relaxed mb-4">
                  Um Ihr Widerrufsrecht auszuüben, müssen Sie uns, der
                </p>
                <div className="bg-[#E8F5E0] p-6 rounded-lg my-6">
                  <p className="font-bold">NOVATUS Energie GmbH</p>
                  <p>Maximiliankorso 60</p>
                  <p>13465 Berlin</p>
                  <p className="mt-2">E-Mail: info@novatus-se.com</p>
                </div>
                <p className="leading-relaxed mb-4">
                  mittels einer eindeutigen Erklärung (z.B. ein per Post versandter Brief oder per E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.
                </p>
                <p className="leading-relaxed">
                  Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
                </p>
              </section>

              {/* Folgen des Widerrufs */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">Folgen des Widerrufs</h2>
                <p className="leading-relaxed mb-4">
                  Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens binnen 14 Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrages bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, dass Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden wir Ihnen wegen dieser Rückzahlung Entgelte berechnen.
                </p>
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 my-6">
                  <p className="leading-relaxed">
                    <strong>Wichtiger Hinweis:</strong> Unter ausdrücklichem Hinweis auf Artikel 246 a § 1 Abs. 2 Satz 1 Nr. 2 des Einführungsgesetzes zum Bürgerlichen Gesetzbuch teilen wir Ihnen mit, dass Sie im Fall des Widerrufs die unmittelbaren Kosten der Rücksendung der an Sie bereits gelieferten Ware zu tragen haben. Die Kostentragungspflicht umfasst insbesondere auch den Fall, dass eine sperrige oder besonders schwere Ware an Sie geliefert worden ist.
                  </p>
                </div>
              </section>

              {/* Unternehmensdaten */}
              <div className="mt-12 pt-8 border-t-2 border-[#1A3A2E]/20">
                <div className="bg-[#E8F5E0] p-6 rounded-lg">
                  <p className="font-bold text-[#1A3A2E] mb-2">NOVATUS Energie GmbH</p>
                  <p>Maximiliankorso 60, 13465 Berlin</p>
                  <p>Geschäftsführer: Christof Schirm</p>
                  <p>Amtsgericht Charlottenburg, HRB 222 580</p>
                  <p>USt.-ID-Nr.: DE 296655 515</p>
                  <p className="mt-3">
                    <strong>Telefon:</strong> +49 (0)30 398205700<br/>
                    <strong>E-Mail:</strong> info@novatus-se.com
                  </p>
                </div>
              </div>

              {/* Link zurück zu AGB */}
              <div className="mt-8 text-center">
                <p className="text-gray-600">
                  Weitere Informationen finden Sie in unseren{' '}
                  <a href="/agb" className="text-[#1A3A2E] hover:underline font-semibold">
                    Allgemeinen Geschäftsbedingungen
                  </a>
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-[#1A3A2E] text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} NOVATUS Energie GmbH • Alle Rechte vorbehalten
          </p>
        </div>
      </div>
    </div>
  );
};

export default WiderrufsPage;
